import React, { useState, useEffect } from 'react';

const SkierAnimation = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const startAnimation = () => {
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 7000);
    };

    // Initial delay
    const initialDelay = setTimeout(() => {
      startAnimation();
    }, 4000);

    // Repeat every 25 seconds
    const interval = setInterval(() => {
      startAnimation();
    }, 25000);

    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden">
      <div 
        className="absolute animate-ski-down"
        style={{
          filter: 'drop-shadow(0 4px 12px rgba(107, 142, 107, 0.4))'
        }}
      >
        {/* Premium Skier SVG */}
        <svg
          width="70"
          height="70"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ transform: 'scaleX(-1) rotate(10deg)' }}
        >
          {/* Dynamic skiing pose */}
          <defs>
            <linearGradient id="skierGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#8FAF8F" />
              <stop offset="100%" stopColor="#5A7D5A" />
            </linearGradient>
          </defs>
          
          {/* Head with helmet */}
          <ellipse cx="48" cy="18" rx="9" ry="10" fill="url(#skierGradient)" />
          <path d="M39 14 Q48 8 57 14" stroke="#5A7D5A" strokeWidth="3" fill="none" strokeLinecap="round" />
          
          {/* Goggles */}
          <ellipse cx="48" cy="17" rx="6" ry="3" fill="#4a6b4a" opacity="0.6" />
          
          {/* Body - dynamic skiing pose */}
          <path 
            d="M48 28 Q55 40 52 52" 
            stroke="url(#skierGradient)" 
            strokeWidth="6" 
            strokeLinecap="round"
            fill="none"
          />
          
          {/* Back arm with pole */}
          <path 
            d="M50 32 L72 28 L85 60" 
            stroke="url(#skierGradient)" 
            strokeWidth="3" 
            strokeLinecap="round"
            fill="none"
          />
          
          {/* Front arm with pole */}
          <path 
            d="M48 36 L28 42 L15 72" 
            stroke="url(#skierGradient)" 
            strokeWidth="3" 
            strokeLinecap="round"
            fill="none"
          />
          
          {/* Pole tips - metallic */}
          <circle cx="85" cy="60" r="2" fill="#8FAF8F" />
          <circle cx="15" cy="72" r="2" fill="#8FAF8F" />
          
          {/* Legs - bent skiing position */}
          <path 
            d="M52 52 Q45 62 38 70" 
            stroke="url(#skierGradient)" 
            strokeWidth="5" 
            strokeLinecap="round"
            fill="none"
          />
          <path 
            d="M52 52 Q58 60 62 68" 
            stroke="url(#skierGradient)" 
            strokeWidth="5" 
            strokeLinecap="round"
            fill="none"
          />
          
          {/* Skis - sleek design */}
          <path 
            d="M25 73 Q38 70 52 73" 
            stroke="#4a6b4a" 
            strokeWidth="4" 
            strokeLinecap="round"
            fill="none"
          />
          <path 
            d="M50 71 Q62 68 78 71" 
            stroke="#4a6b4a" 
            strokeWidth="4" 
            strokeLinecap="round"
            fill="none"
          />
        </svg>
        
        {/* Snow spray particles */}
        <div className="absolute -left-4 top-12">
          {[...Array(12)].map((_, i) => (
            <div
              key={i}
              className="absolute rounded-full bg-white animate-snow-particle"
              style={{
                width: `${3 + Math.random() * 4}px`,
                height: `${3 + Math.random() * 4}px`,
                left: `${-i * 6}px`,
                top: `${(i % 4) * 8}px`,
                animationDelay: `${i * 0.08}s`,
                opacity: 0.7 - (i * 0.05),
                boxShadow: '0 0 6px rgba(255, 255, 255, 0.8)',
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkierAnimation;
